import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'gold';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-wkm-navy-700 text-white hover:bg-wkm-navy-800 focus:ring-wkm-navy-700 shadow-sm hover:shadow-md',
    secondary: 'bg-wkm-slate-100 text-wkm-slate-900 hover:bg-wkm-slate-200 focus:ring-wkm-slate-500',
    outline: 'border-2 border-wkm-navy-700 bg-transparent hover:bg-wkm-navy-50 text-wkm-navy-700 focus:ring-wkm-navy-700',
    ghost: 'bg-transparent hover:bg-wkm-slate-100 text-wkm-slate-700 focus:ring-wkm-slate-500',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-600 shadow-sm',
    gold: 'bg-wkm-gold-500 text-wkm-navy-900 hover:bg-wkm-gold-600 focus:ring-wkm-gold-500 shadow-sm hover:shadow-md font-semibold'
  };
  const sizes = {
    sm: 'h-8 px-3 text-xs',
    md: 'h-10 px-5 py-2 text-sm',
    lg: 'h-12 px-7 text-base'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`} {...props} data-id="element-220">
      {children}
    </button>;
}